import { AdventureBox } from '@/Assets/Icons/AdventureBox';
import { AdventuresTabs } from '../../types';
import { TabsList, TabsTrigger } from '@radix-ui/react-tabs';
import PlaceholderBg from '../../assets/PlaceholderBg.png';

export function MyAdventuresPlaceholder() {
  return (
    <div className="quests-adventures--placeholder">
      <div className="quests-adventures--placeholder-bg">
        <img src={PlaceholderBg} alt="" />
      </div>
      <AdventureBox
        width={63}
        height={63}
        className="quests-adventures--placeholder-icon"
      />
      <div className="quests-adventures--placeholder-heading">
        You haven’t completed any adventures yet
      </div>
      <div className="quests-adventures--placeholder-text">
        Check active campaigns, complete quests and earn extra points and
        multipliers.
      </div>
      <TabsList asChild>
        <TabsTrigger
          value={AdventuresTabs.ActiveAdventures}
          className="btnGradient quests-adventures--placeholder-action"
        >
          See active campaigns
        </TabsTrigger>
      </TabsList>
    </div>
  );
}
